import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { Observable } from 'rxjs';
import { tap, mergeMap } from 'rxjs/operators';
import { CouponService } from '../../_services/coupon.service';
import { Organization } from '../../_models/Organization';
import { OrganizationService } from '../../_services/organization.service';

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['../../_shared/base.management.component.css']
})

export class OrganizationsComponent implements OnInit {
  public loading = true;
  public organizations: Organization[] = [];
  public displayOrganizations: Organization[] = [];

  public searchText: string;


  constructor(private router: Router,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private organizationService: OrganizationService) {

  }

  ngOnInit() {
      this.loadOrganization().subscribe();
  }

  public search() {
    if (!this.searchText) {
      return;
    }
    const search = this.searchText.toLowerCase();
    this.displayOrganizations = this.organizations.filter(o => o.name.toLowerCase().indexOf(search) !== -1 || !search);
  }

  public deleteOrganization(id: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to delete this organization?', this.viewRef).then(result => {
      if (result) {
        this.organizationService.deleteOrganization(id).pipe(
          tap(
            () => {
              this.loading = false;
            },
            () => {
              this.loading = false;
              this.dialogService.alert('Error', 'Unable to delete organization', this.viewRef);
            }
          ),
          mergeMap(() => this.loadOrganization())
        ).subscribe();
      }
    });
  }

  public editOrganization(id: number) {
    this.router.navigate(['/portal/admin/organization/', id]);
  }

  private loadOrganization(): Observable<any> {
    return this.organizationService.getAllOrganizations().pipe(
      tap(
        data => {
          this.organizations = this.displayOrganizations = data;
          this.loading = false;
        },
        () => {
          this.dialogService.alert('Error', 'Unable to load organizations', this.viewRef);
          this.loading = false;
        }
      )
    );
  }

  public newOrganization() {
    this.router.navigate(['/portal/admin/organization/create']);
  }
}
